/**
 * Web Vitals Collector
 * Collects Core Web Vitals metrics using web-vitals library
 */

import { onCLS, onINP, onFCP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { BaseCollector } from './BaseCollector.js';
import type { EventBus } from '../core/EventBus.js';
import { createWebVitalEvent, type WebVitalName, type WebVitalRating } from '../models/WebVitalEvent.js';

export class WebVitalsCollector extends BaseCollector {
  constructor(
    eventBus: EventBus,
    sessionId: string,
    userId: string | null,
    debug: boolean = false
  ) {
    super('WebVitalsCollector', eventBus, sessionId, userId, debug);
  }

  initialize(): void {
    this.log('Initializing Web Vitals collection');

    const onMetric = (metric: Metric) => {
      const baseMetadata = this.getBaseMetadata();
      
      const webVitalEvent = createWebVitalEvent(baseMetadata, {
        name: metric.name as WebVitalName,
        value: metric.value,
        rating: metric.rating as WebVitalRating,
        delta: metric.delta,
        id: metric.id
      });

      this.emit('event:collected', webVitalEvent);
      this.log(`Collected ${metric.name}: ${metric.value} (${metric.rating})`);
    };

    // Register all web vitals
    onCLS(onMetric);
    onINP(onMetric);
    onFCP(onMetric);
    onLCP(onMetric);
    onTTFB(onMetric);

    this.isInitialized = true;
  }

  destroy(): void {
    // Web vitals uses event listeners that are automatically cleaned up
    this.isInitialized = false;
    this.log('Destroyed');
  }
}

